import Dexie, { type EntityTable } from 'dexie';
import type {
  AssetBlobRecord,
  DraftJournalRecord,
  ProjectDocRecord,
  ProjectMetaRecord,
} from './types';

/**
 * Local persistence for Fotoboek Studio. Everything here is scoped to this
 * browser/device — projects created as a guest never leave it unless the
 * user explicitly exports a backup or signs in and opts into cloud sync.
 */
export class FotoboekDatabase extends Dexie {
  projectsMeta!: EntityTable<ProjectMetaRecord, 'id'>;
  projectDocs!: EntityTable<ProjectDocRecord, 'projectId'>;
  draftJournal!: EntityTable<DraftJournalRecord, 'projectId'>;
  assetBlobs!: EntityTable<AssetBlobRecord, 'key'>;

  constructor() {
    super('fotoboek-studio');
    this.version(1).stores({
      projectsMeta: 'id, updatedAt, ownerMode, syncState',
      projectDocs: 'projectId, revision',
      draftJournal: 'projectId, revision',
      assetBlobs: 'key, projectId, assetId, kind',
    });
  }
}

let dbInstance: FotoboekDatabase | null = null;

export function getDb(): FotoboekDatabase {
  if (!dbInstance) {
    dbInstance = new FotoboekDatabase();
  }
  return dbInstance;
}

/** For tests: force a fresh database instance bound to the current fake backend. */
export function resetDbInstance(): void {
  dbInstance?.close();
  dbInstance = null;
}
